import React from "react";
import "../style/vision.css";
import visionImage2 from "../assets/visionImage2.png";
import visionImage3 from "../assets/visionImage3.png";
import visionGreen from "../assets/visionGreen.png";
import visionBlue from "../assets/visionBlue.png";
import visionWheel from "../assets/visionWheel.png";
import love from "../assets/love.png";
import vision5 from "../assets/vision5.png";
import { NavLink } from "react-router-dom";

const VisionAndMission = () => {
  return (
    <div className="vision">
      <section className="vision-section1">
        <h1>Our Mission & Vision</h1>
        <span>
          Guiding principles that drive our commitment to exceptional care and
          support for
          <br /> individuals with disabilities across the UK.
        </span>
      </section>
      <section className="vision-section2">
        <img src={visionImage2} alt="vision" loading="lazy" />
        <h4>Our Mission</h4>
        <div className="vision-section2-div">
          <h4>
            "To provide exceptional, person-centered residential care that
            empowers individuals with learning disabilities, mental health
            challenges, and physical disabilities to live with dignity,
            independence, and joy."
          </h4>
          <h5>
            We are committed to creating supportive environments where
            <br /> every individual can thrive, make meaningful choices, and
            build
            <br /> fulfilling lives. Through professional care, family
            partnership,
            <br /> and community integration, we help people achieve their
            <br />
            personal goals and aspirations.
          </h5>
        </div>
      </section>

      <section className="vision-section3">
        <img src={visionImage3} alt="vision" loading="lazy" />
        <h3>Our Mission</h3>
        <div className="vision-section2-div">
          <h4>
            "To provide exceptional, person-centered residential care that
            empowers individuals with learning disabilities, mental health
            challenges, and physical disabilities to live with dignity,
            independence, and joy."
          </h4>
          <h5>
            We are committed to creating supportive environments where every
            individual can thrive, make meaningful choices, and build fulfilling
            lives. Through professional care, family partnership, and community
            integration, we help people achieve their personal goals and
            aspirations.
          </h5>
        </div>
      </section>
      <section className="vision-section4">
        <h1>Supporting People with Disabilities</h1>
        <div className="vision-section4-div1">
          {/* item */}
          <div className="vision-section4-item">
            <img src={visionGreen} alt="vision" loading="lazy" />
            <h3>Learning Disabilities</h3>
            <span>
              Providing tailored support that promotes learning, skill
              development, and independence while respecting individual pace and
              preferences.
            </span>
          </div>
          {/* item2 */}
          <div className="vision-section4-item">
            <img src={visionBlue} alt="vision" loading="lazy" />
            <h3>Mental Health Challenges</h3>
            <span>
              Offering compassionate mental health support with professional
              counseling, medication management, and therapeutic activities.
            </span>
          </div>
          {/* item3 */}
          <div className="vision-section4-item">
            <img src={visionWheel} alt="vision" loading="lazy" />
            <h3>Physical Disabilities</h3>
            <span>
              Ensuring accessible environments and specialized care that
              supports mobility, comfort, and participation in daily activities.
            </span>
          </div>
        </div>
      </section>
      <section className="vision-section5">
        <h3 style={{ marginTop: "50px", paddingTop: "50px" }}>
          Our Guiding Principles
        </h3>
        <div className="vision-section5-div">
          <div className="vision-section5-div1">
            <div className="vision-section5-items">
              <span>
                <img src={love} alt="love" loading="lazy" />
                <h3>Compassionate Care</h3>
              </span>
              <h4>
                Providing care with empathy, understanding, and
                <br /> genuine concern for each individual's wellbeing.
              </h4>
            </div>
            <div className="vision-section5-items">
              <span>
                <img src={visionImage2} alt="vision" loading="lazy" />
                <h3>Person-Centered Approach</h3>
              </span>
              <h4>
                Providing care with empathy, understanding, and
                <br /> genuine concern for each individual's wellbeing.
              </h4>
            </div>
          </div>
          <div className="vision-section5-div2">
            <div className="vision-section5-items">
              <span>
                <img src={vision5} alt="vision" loading="lazy" />
                <h3>Professional Excellence</h3>
              </span>
              <h4>
                Maintaining the highest standards of care through
                <br /> continuous training, development, and best practices.
              </h4>
            </div>
            <div className="vision-section5-items">
              <span>
                <img src={visionImage3} alt="vision" loading="lazy" />
                <h3>Transparency & Trust</h3>
              </span>
              <h4>
                Building lasting relationships based on open
                <br /> communication, honesty, and mutual respect.
              </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="vision-section6">
        <div className="vision-section6-div1">
          <h1>Our Values in Action</h1>
          <h3>
            See how our mission and vision translate into daily practice through
            our core
            <br /> values and dedicated team approach.
          </h3>

          <div className="vision-section6-div1-navs">
            <NavLink to="/value">Explore Our Values</NavLink>
            <NavLink to="/meet-our-team">Meet Our Team</NavLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisionAndMission;
